import { ImageView } from "~/pages/manifold-nextgen/components/conversations/ImageView";
import type { ArtifactPreview } from "~/services/artifacts";

function imageUrl(content: ArtifactPreview["content"]): string | null {
  if (!content || typeof content !== "object" || Array.isArray(content)) return null;
  const url = (content as Record<string, unknown>).url;
  return typeof url === "string" ? url : null;
}

export const ImageArtifact = ({ preview }: { preview: ArtifactPreview }) => {
  const src = imageUrl(preview.content);

  if (!src) {
    return <div className="my-3 text-sm text-destructive">Unexpected image preview shape.</div>;
  }

  return (
    <div className="my-3">
      <ImageView
        url={src}
        filename={preview.filename}
        artifactName={preview.artifact_name}
        summary={preview.summary}
      />
    </div>
  );
};
